// Generated by LiveScript 1.6.0
var ref$, id, log, ResDiaryShow;
ref$ = require('utils'), id = ref$.id, log = ref$.log;
module.exports = ResDiaryShow = function($host, config, $$){
  var $button, $embed, $content, state, toggle;
  $button = $$('[data-show-resdiary-embed]');
  $embed = $$('[data-resdiary-embed]');
  $content = $$('[data-hide-when-resdairy-shown]');
  state = {
    shown: false,
    text: $button.text()
  };
  toggle = function(mode){
    state.shown = mode;
    if (state.shown) {
      $embed.show();
      $content.hide();
      return $button.text('Done');
    } else {
      $embed.hide();
      $content.show();
      return $button.text(state.text);
    }
  };
  $button.on('click', function(){
    return toggle(!state.shown);
  });
  return {
    toggle: toggle
  };
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInJlc2RpYXJ5LXNob3cubHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFDQSxJQUFBLEdBQWMsT0FBZCxDQUFzQixPQUFBLENBQXRCLEVBQUUsRUFBVSxDQUFBLENBQUEsQ0FBWixJQUFBLENBQUEsRUFBQSxFQUFNLEdBQU0sQ0FBQSxDQUFBLENBQVosSUFBQSxDQUFBO0FBR0EsTUFBTSxDQUFDLE9BQVEsQ0FBQSxDQUFBLENBQUUsWUFBYSxDQUFBLENBQUEsQ0FBRSxRQUFBLENBQUEsS0FBQSxFQUFBLE1BQUEsRUFBQSxFQUFBOztFQUc5QixPQUFTLENBQUEsQ0FBQSxDQUFFLEdBQUcsNEJBQUQ7RUFDYixNQUFTLENBQUEsQ0FBQSxDQUFFLEdBQUcsdUJBQUQ7RUFDYixRQUFTLENBQUEsQ0FBQSxDQUFFLEdBQUcsaUNBQUQ7RUFHYixLQUFNLENBQUEsQ0FBQSxDQUNKO0lBQUEsT0FBTztJQUNQLE1BQU0sT0FBTyxDQUFDLEtBQUk7RUFEbEI7RUFJRixNQUFPLENBQUEsQ0FBQSxDQUFFLFFBQUEsQ0FBQSxJQUFBO0lBQ1AsS0FBSyxDQUFDLEtBQU0sQ0FBQSxDQUFBLENBQUU7SUFFZCxJQUFHLEtBQUssQ0FBQyxLQUFUO01BQ0UsTUFBTSxDQUFDLEtBQUk7TUFDWCxRQUFRLENBQUMsS0FBSTthQUNiLE9BQU8sQ0FBQyxLQUFLLE1BQUE7S0FDZjtNQUNFLE1BQU0sQ0FBQyxLQUFJO01BQ1gsUUFBUSxDQUFDLEtBQUk7YUFDYixPQUFPLENBQUMsS0FBSyxLQUFLLENBQUMsSUFBTjs7O0VBR2pCLE9BQU8sQ0FBQyxHQUFHLFNBQVEsUUFBQSxDQUFBO1dBQUcsT0FBTyxDQUFJLEtBQUssQ0FBQyxLQUFWO0dBQWxCO1NBR1g7SUFBQSxRQUFRO0VBQVIiLCJzb3VyY2VzQ29udGVudCI6W251bGxdfQ==

